<!-- 引导页面 -->
<template>
<!--    <div class="giudepage"> -->
<!--        <div class="giudepage_top">-->
<!--            <div class="giudepage_top_one"></div>-->
<!--            <div class="giudepage_top_two"></div>-->
<!--            <div class="giudepage_top_three"></div>-->
<!--            <div class="giudepage_top_four"></div>-->
<!--        </div>-->
<!--        <div class="giudepage_bottom" @click="handleIknow">我知道了</div>-->
<!--        <div class="good_show">推荐使用360、火狐、谷歌等浏览器、1920*1080分辨率进行观看</div>-->
<!--    </div>-->
</template>

<script>
export default {
    name: 'guidePage',
    methods: {
        handleIknow() {
            this.$emit('iknow')
        }
    }
}
</script>

<style lang="scss" scoped>
.giudepage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.86);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .giudepage_top {
        width: 100%;
        display: flex;
        justify-content: center;
        .giudepage_top_one {
            width: 286px;
            height: 288px;
            background: url('~@/assets/img/guide/guide-icon-one.png') no-repeat center;
            background-size: contain;
            margin-right: 60px;
        }
        .giudepage_top_two {
            width: 286px;
            height: 288px;
            background: url('~@/assets/img/guide/guide-icon-two.png') no-repeat center;
            background-size: contain;
            margin-right: 60px;
            margin-left: 60px;
        }
        .giudepage_top_three {
            width: 286px;
            height: 288px;
            background: url('~@/assets/img/guide/guide-icon-three.png') no-repeat center;
            background-size: contain;
            margin-right: 60px;
            margin-left: 60px;
        }
        .giudepage_top_four {
            width: 286px;
            height: 306px;
            background: url('~@/assets/img/guide/guide-icon-four.png') no-repeat center;
            background-size: contain;
            margin-left: 60px;
        }
    }    
    .giudepage_bottom {
        width: 136px;
        height: 38px;
        border:2px solid #fff;
        border-radius: 40px;
        background: transparent;
        cursor: pointer;
        text-align: center;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 114px;
        color: #fff;
    }
    .good_show {
        background: transparent;
        text-align: center;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 60px;
        color: #fff;
    }
}
</style>
